const updates = [
  {
    date: '2026-07-29',
    title: '《星界轮回》第208话更新上线',
    desc: '热门奇幻韩漫最新话已更新，下拉式阅读体验全新章节的精彩剧情转折。',
    tag: '韩漫更新',
  },
  {
    date: '2026-07-28',
    title: '《暗影猎手》第156话热血来袭',
    desc: '日漫热血大作最新话，战斗场景燃爆全场，下拉式看漫更过瘾。',
    tag: '日漫更新',
  },
  {
    date: '2026-07-28',
    title: '平台新上线50+部经典日漫全集',
    desc: '一次性收录多部经典完结日漫，下拉式全集畅读，补番好时机。',
    tag: '资源上新',
  },
  {
    date: '2026-07-27',
    title: '《甜蜜陷阱》韩漫新作首发',
    desc: '高人气新作韩漫正式登陆亲亲漫画网，全彩下拉式阅读，画风精美。',
    tag: '新作首发',
  },
  {
    date: '2026-07-26',
    title: '下拉式阅读引擎性能优化完成',
    desc: '图片加载速度提升40%，滑动流畅度优化，阅读体验全面升级。',
    tag: '系统优化',
  },
  {
    date: '2026-07-25',
    title: '《时空旅人》第三季连载启动',
    desc: '人气奇幻日漫第三季开更，下拉式全集回顾前两季已同步上线。',
    tag: '连载启动',
  },
  {
    date: '2026-07-24',
    title: '恋爱漫画专题「盛夏心动」上线',
    desc: '精选50部夏日恋爱漫画，下拉式甜蜜阅读，陪你度过浪漫夏天。',
    tag: '专题活动',
  },
  {
    date: '2026-07-23',
    title: '新增漫画分类「国漫专区」预告',
    desc: '应漫友呼声，国漫专区正在筹备中，敬请期待更多下拉式漫画内容。',
    tag: '平台动态',
  },
  {
    date: '2026-07-22',
    title: '《异界事务所》突破200话纪念',
    desc: '韩漫热门连载达成200话里程碑，下拉式全集回顾活动限时开启。',
    tag: '里程碑',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">更新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            亲亲漫画网最新漫画更新、平台动态与活动信息一览
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updates.map((item, idx) => (
                <div key={idx} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-12">
                  <div className="absolute left-3 md:left-[17px] top-1.5 w-[9px] h-[9px] rounded-full bg-primary-500 ring-4 ring-background-100"></div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">{item.tag}</span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}